import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import moment from 'moment';
import styled from 'styled-components';
import { Button, TextField, useTheme } from '@material-ui/core';
import { SagnificantText } from 'UIKit/Form';
import { Box, Flex } from 'UIKit/Grid';
import { cleaRequest } from '@/modules/Requests';

import {
  fetchSaveOlimpicResult,
  REQUEST_GET_OLIMPIC_ACTIVE,
  REQUEST_SAVE_OLIMPIC_RESULT,
  fetchActiveOlimpics,
} from '@/modules/Olimpic';
import StyledButton from 'sama_global/components/StyledButton';
import ColorLink from '@/components/UIKit/ColorLink';
import { useLoadbar } from 'sama_global/utils/hooks/loadbar';
import { useSnackbarListener } from 'sama_global/utils/hooks/snackbar';

export const LinkStyled = styled.a`
  color: red;
`;

const About = ({ loadData, changeLink, requests, olimpic, clear }) => {
  const [link, setLink] = useState('');
  const { palette } = useTheme();

  const participant = olimpic?.participant;

  useEffect(() => {
    loadData();

    return () => {
      clear(REQUEST_SAVE_OLIMPIC_RESULT);
    };
  }, []);

  useEffect(() => {
    if (participant) {
      setLink(participant.link);
    }
  }, [participant]);

  useLoadbar(REQUEST_GET_OLIMPIC_ACTIVE);

  const requestSave = requests[REQUEST_SAVE_OLIMPIC_RESULT];

  useSnackbarListener(requestSave?.errorMessage);
  useSnackbarListener(requestSave?.success && 'SAVED', 'success');

  return (
    <Box
      w={1}
      p={4}
      py={20}
      m="auto"
      style={{ wordBreak: 'break-word', maxWidth: 1000 }}
    >
      {!olimpic && (
        <SagnificantText>
          <FormattedMessage id="OLIMPIC_NOT_FOUND" defaultMessage="" />
        </SagnificantText>
      )}
      {olimpic && (
        <>
          <SagnificantText>
            <FormattedMessage id="OLIMPIC_TITLE" defaultMessage="" />
            {' "'}
            {olimpic.name}
            {'" '}
            <FormattedMessage id="WILL_PASS" defaultMessage="" />{' '}
            <>
              <FormattedMessage id="FROM" defaultMessage="" />{' '}
              {moment(olimpic.start)
                .locale('en')
                .format('Do MMMM YYYY HH:mm')}{' '}
              <FormattedMessage id="TO" defaultMessage="" />{' '}
              {moment(olimpic.end)
                .locale('en')
                .format('Do MMMM YYYY HH:mm')}
            </>
          </SagnificantText>
          <Box mt={1} dangerouslySetInnerHTML={{ __html: olimpic.desc }} />
          <Box mt={4}>
            <FormattedMessage id="OLIMPIC_REGLAMENT" defaultMessage="" />:{' '}
            <ColorLink to={olimpic.reglament} color={palette.action.main}>
              {olimpic.reglament}
            </ColorLink>
          </Box>
          <Box mt={4}>
            <FormattedMessage id="OLIMPIC_GROUPS_TASKS" defaultMessage="" />:{' '}
            <ColorLink to={olimpic.tasks} color={palette.action.main}>
              {olimpic.tasks}
            </ColorLink>
          </Box>
          <Box mt={4}>
            <FormattedMessage id="OLIMPIC_SYLLABUS" defaultMessage="" />:{' '}
            <ColorLink to={olimpic.syllabus} color={palette.action.main}>
              {olimpic.syllabus}
            </ColorLink>
          </Box>
          {olimpic.start_video !== '' && olimpic.start_video != null && (
            <Box mt={4}>
              <iframe
                width="560"
                height="315"
                src={olimpic.start_video}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </Box>
          )}

          {participant && (
            <Box mt={6}>
              <SagnificantText>
                <FormattedMessage id="OLIMPIC_REGISTERED" defaultMessage="" />
                {': '}
                <FormattedMessage id="CATEGORY" defaultMessage="" />:{' '}
                {participant.category}
              </SagnificantText>
            </Box>
          )}

          {participant && participant.result ? (
            <Box mt={4}>
              <SagnificantText>
                <FormattedMessage id="OLIMPIC_CONGRATS" defaultMessage="" />.
              </SagnificantText>
              <Box mt={4}>
                <Flex gridGap={10}>
                  <TextField
                    variant="outlined"
                    label={
                      <FormattedMessage id="LINK_BY_VIDEO" defaultMessage="" />
                    }
                    onChange={e => setLink(e.currentTarget.value)}
                    value={link}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => changeLink(olimpic._id, { link })}
                  >
                    <FormattedMessage id="SAVE" defaultMessage="" />
                  </Button>
                </Flex>
              </Box>
            </Box>
          ) : (
            <Flex mt={10}>
              {!participant && (
                <Box mr={6}>
                  <StyledButton
                    component={Link}
                    to="/olimpic/participate"
                    variant="contained"
                  >
                    <FormattedMessage id="PARTICIPATE" defaultMessage="" />
                  </StyledButton>
                </Box>
              )}
              {participant && (
                <>
                  {moment().isBefore(olimpic.start) && (
                    <Box mr={6}>
                      {olimpic.active_simulation ? (
                        <StyledButton
                          component={Link}
                          to="/olimpic/run/simulate"
                          variant="contained"
                        >
                          <FormattedMessage
                            id="OLIMPIC_SIMULATOR"
                            defaultMessage=""
                          />
                        </StyledButton>
                      ) : (
                        <FormattedMessage
                          id="SIMULATE_PAUSE"
                          defaultMessage="simulate has been paused"
                        />
                      )}
                    </Box>
                  )}
                  {moment().isBetween(olimpic.start, olimpic.end) && (
                    <Box>
                      <StyledButton
                        component={Link}
                        to="/olimpic/sama/pre-run"
                        variant="contained"
                      >
                        <FormattedMessage id="OLIMPIC_RUN" defaultMessage="" />
                      </StyledButton>
                    </Box>
                  )}
                </>
              )}
            </Flex>
          )}
        </>
      )}
    </Box>
  );
};

About.propTypes = {
  loadData: PropTypes.func.isRequired,
  changeLink: PropTypes.func.isRequired,
  clear: PropTypes.func.isRequired,
  olimpic: PropTypes.object.isRequired,
  requests: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  user: state.user,
  requests: state.requests,
  olimpic: state.olimpic.sama,
});

const mapDispatchToProps = dispatch => ({
  loadData() {
    dispatch(fetchActiveOlimpics());
  },
  changeLink(id, formData) {
    dispatch(fetchSaveOlimpicResult(id, 'exam', formData));
  },
  clear(request) {
    dispatch(cleaRequest(request));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(About);
